module.exports = __webpack_public_path__ + "static/media/now-hiring-mobile-fr.d9494f26.jpg";